import { Job } from "~/components/build/Show/lib/types";

interface Props {
  job: Job;
}

export default function AnnotationsCount({ job }: Props) {
  const { annotationsCount } = job.statistics;

  if (!annotationsCount) {
    return null;
  }

  return <span className="badge badge--outline tabular-numerals ml-1">{annotationsCount}</span>;
}
